import type {
    RouteRecordRaw
} from 'vue-router'

const routes: RouteRecordRaw[] = [{
    "path": "/apaas",
    "component": () => import('@/router/Apaas/index.vue'),
    "children": [{
        "path": "approval",
        "component": () => import('@/views/approval.vue'),
        "meta": {
            "pageId": "2-b43057e4-dee3-4f38-b9db-121f08af5751",
            "pageName": "商品审核",
            "isCache": 0
        }
    }]
}]

export default routes